import createValueModule from "@/redux/create-value-module";

import {
    $WishlistSidebarModuleName,
    TWishlistSidebarState
} from "./wishlistSidebar.types";

const { constants: _constants, actions } =
    createValueModule<TWishlistSidebarState>($WishlistSidebarModuleName, {
        visible: false
    });

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
